
































/* eslint-disable class-methods-use-this */
import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
// import { getModule } from 'vuex-module-decorators';
import TopNavigation from '@/components/global/TopNavigation.vue';
import Sidebar from '@/components/global/Sidebar.vue';
import PageFooter from '@/components/PageFooter.vue';
import PageLoading from '@/components/PageLoading.vue';
// import UserModule from '@/store/modules/user';
// import { AdminRoles } from '@/configs/role';

@Component({
  components: {
    PageFooter,
    PageLoading,
    TopNavigation,
    Sidebar,
  },
})
export default class LayoutDashboard extends Vue {
  // userModule: UserModule | null = null;

  @Getter('menu/getMenuType') getMenuType!: string;

  @Getter('loading/isLoading') isLoading!: boolean;

  @Getter('user/currentUser') currentUser!: {};

  // debugUserWithRoot() {
  //   if (process.env.NODE_ENV === 'development' && this.userModule) {
  //     this.userModule.setUser({
  //       id: 1,
  //       name: 'Ted',
  //       token: process.env.VUE_APP_DEV_TOKEN as string,
  //       role: AdminRoles.root,
  //     });
  //   }
  // }

  // debugUserWithAdmin() {
  //   if (process.env.NODE_ENV === 'development' && this.userModule) {
  //     this.userModule.setUser({
  //       token: 'DADD3D590C568D504D152EF4214206E6',
  //       id: 2,
  //       name: 'serena',
  //       role: 2,
  //     });
  //   }
  // }

  // debugUserWithStaff() {
  //   if (process.env.NODE_ENV === 'development' && this.userModule) {
  //     this.userModule.setUser({
  //       id: 1,
  //       name: 'Ted',
  //       token: process.env.VUE_APP_DEV_TOKEN as string,
  //       role: AdminRoles.staff,
  //     });
  //   }
  // }

  // debugUserWithGuest() {
  //   if (process.env.NODE_ENV === 'development' && this.userModule) {
  //     this.userModule.clearUser();
  //   }
  // }

  // beforeMount() {
  //   this.userModule = getModule(UserModule, this.$store);
  // }

  mounted() {
    setTimeout(() => {
      document.body.classList.add('default-transition');
    }, 100);
    document.body.classList.add('rounded');
  }

  beforeDestroy() {
    document.body.classList.remove('default-transition', 'rounded');
  }
}
